/* Fixed-city adapter: native map variant + existing special-frame price buckets.
   Shared frame UI/readiness/catalog; never enters custom City Builder V3. */
(() => {
  'use strict';
  if (window.nfStaticFrameGateInitialized) return;
  window.nfStaticFrameGateInitialized = true;
  const entries = new Map();
  const motor = () => window.nfRammeMotor;
  const api = window.nfCityFrameConfigurator;
  const prices = window.NF_CITY_PRICE_CONTRACT;
  const kr = minor => `${new Intl.NumberFormat('da-DK').format(minor / 100)} kr.`;
  const escapeHtml = value => { const n=document.createElement('span'); n.textContent=String(value); return n.innerHTML; };
  let buckets = [], loading = true;
  const readiness = {valid:false,pattern:new Set(),proMaterial:new Set(),reason:'Validerer materialer'};
  const component = e => document.querySelector(`product-form-component[data-product-id="${e.config.productId}"]`);
  const selected = e => e.config.variants.find(v => String(v.id) === component(e)?.querySelector('[name="id"]')?.value);
  const quantity = e => Number(component(e)?.querySelector('[name="quantity"]')?.value || 1);
  const getSize = e => parseInt(selected(e)?.option1,10);
  const pro = e => e.ramme.overflade === 'proMaterial';
  const material = e => motor().proMaterialer().find(m => m.id === e.ramme.proMateriale);
  const ready = (mode,id) => mode === 'solid' ? id === motor().GLAT_ID : readiness.valid && readiness[mode]?.has(id);
  const description = e => pro(e) ? (material(e)?.navn ? `${material(e).navn} · Pro Material` : 'Vælg et Pro Material') : `${motor().farve(e.ramme.farve).navn} · Ensfarvet`;
  function detail(e) {
    const r=e.root, c=motor().farve(e.ramme.farve), m=pro(e) ? material(e) : null;
    const close=m ? motor().materialeCloseup(m.id,480) : null;
    r.querySelector('[data-frame-detail]').hidden=e.choice !== 'med';
    r.querySelector('[data-frame-detail-title]').textContent=description(e);
    r.querySelector('[data-frame-detail-note]').textContent=m ? `Pro Material · ${m.familieNavn}` : `Ensfarvet · ${c.navn}`;
    const n=r.querySelector('[data-frame-detail-corner]');
    for(const [key,value] of Object.entries({kant:'28%',farve:c.swatch,flade:close?.url ? `url("${close.url}")` : 'none',stoerrelse:close?.size || 'cover',gentag:close?.repeat || 'no-repeat',blend:close?.blend || 'normal'})) n.style.setProperty('--nf-hjoerne-'+key,value);
    n.dataset.flade=m ? 'proMaterial' : 'solid'; n.dataset.design=m?.id || ''; n.dataset.closeupSource=close?.source || '';
  }
  function calculation(e) {
    const variant=selected(e), size=getSize(e), count=quantity(e);
    const style=String(variant?.option2).toLowerCase() === 'hvid' ? 'hvid' : 'farve';
    const rule=prices.sizes[String(size)];
    if(!variant?.available || !rule || !Number.isSafeInteger(count) || count<1 || count>999) return {error:'Vælg en tilgængelig størrelse og et gyldigt antal.'};
    // Shopify variant data is the charged base price. Never disguise a catalog mismatch.
    if(variant.price !== rule.base_minor[style]) return {error:'Prisen for denne variant er ved at blive opdateret. Vælg en anden variant eller prøv igen senere.'};
    const withFrame=e.choice==='med';
    if(withFrame && pro(e) && !ready('proMaterial',material(e)?.id)) return {error:'Vælg et godkendt Pro Material.'};
    const surcharge=withFrame ? rule.frame_surcharge_minor[pro(e)?'pro':'klassisk'] : 0;
    const parts=withFrame ? motor().findVarianterTilPraecisTotal(surcharge/100,buckets) : [];
    if(withFrame && (loading || parts.reduce((sum,x)=>sum+x.price*x.quantity*100,0)!==surcharge)) return {error:loading?'Indlæser billedrammens pris…':'Billedrammen kan ikke bestilles lige nu. Prøv igen senere.'};
    return {variant,size,style,count,withFrame,surcharge,parts,total:(variant.price+surcharge)*count};
  }
  function collect() {
    for(const root of document.querySelectorAll('[data-nf-static-gate]')) {
      let config; try {config=JSON.parse(root.querySelector('[data-nf-gate-config]').textContent);} catch {continue;}
      const key=String(config.productId), old=entries.get(key);
      if(old?.root===root) continue;
      const e={config,root,choice:old?.choice || 'med',busy:old?.busy || false,error:'',signature:'',ramme:old?.ramme || {farve:'sort',overflade:'solid',proMateriale:'',proKategori:'',proSoegning:''}};
      e.ui=api.create({root,ramme:e.ramme,surfaceReadiness:readiness,motor,medRamme:()=>e.choice==='med',proValgt:()=>pro(e),rammeUdtryk:()=>description(e),getSize:()=>getSize(e),surfaceChoiceReady:ready,aktivtMateriale:()=>material(e),opdaterRammeDetalje:()=>detail(e),escapeHtml});
      entries.set(key,e);
    }
  }
  function setText(node,text) {if(node && node.textContent!==text) node.textContent=text;}
  function buttonText(node,text) {
    if(!node) return;
    if(!node.querySelector('[ref]')) {setText(node,text);return;}
    let label=node.querySelector('[data-nf-gate-label]');
    if(!label) {for(const child of node.childNodes) {if(child.nodeType===Node.TEXT_NODE) child.textContent='';else if(child.nodeType===Node.ELEMENT_NODE) child.hidden=true;} label=document.createElement('span');label.dataset.nfGateLabel='';node.prepend(label);}
    setText(label,text);
  }
  function sync() {
    collect();
    for(const e of entries.values()) {
      if(!e.root.isConnected) continue;
      const c=calculation(e), sig=JSON.stringify([selected(e)?.id,quantity(e),e.choice,e.ramme,loading,readiness.valid,e.busy,e.error]);
      if(sig===e.signature) continue;
      e.signature=sig;
      for(const r of e.root.querySelectorAll('input[name^="nf-frame-"]')) r.checked=r.value===e.choice;
      e.root.querySelector('[data-frame-panel]').hidden=e.choice!=='med';
      if(prices.sizes[String(getSize(e))]) e.ui.render();
      const total=e.root.querySelector('[data-nf-static-total]');
      setText(total,c.error?'—':kr(c.total));
      setText(e.root.querySelector('[data-nf-static-breakdown]'),c.error?'':`Bykort ${kr(c.variant.price)} + billederamme ${kr(c.surcharge)}${c.count>1 ? ` · ${c.count} stk.` : ''}`);
      setText(e.root.querySelector('[data-nf-frame-status]'),e.error || (e.busy?'Lægger i kurven…':c.error || (c.size===44?'44 × 44 cm: fire 22 × 22 cm kortmoduler, samlet i én yderramme.':'22 × 22 cm: ét samlet kort.')));
      const scope=`product-form-component[data-product-id="${e.config.productId}"], sticky-add-to-cart[data-product-id="${e.config.productId}"]`;
      for(const el of document.querySelectorAll(scope)) {
        for(const input of el.querySelectorAll('[name="id"]')) input.disabled=true;
        for(const b of el.querySelectorAll('button[name="add"], .sticky-add-to-cart__button')) {
          b.disabled=!!c.error || e.busy;
          const label=e.busy?'Lægger i kurven…':c.error?'Vælg bykort og billederamme':`Læg i kurv · ${kr(c.total)}`;
          buttonText(b.querySelector('.add-to-cart-text__content'),label);b.setAttribute('aria-label',label);
        }
      }
    }
  }
  let queued=false;
  function schedule() {if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});}
  function entryFor(target) {
    const root=target.closest?.('[data-nf-static-gate]');
    if(root) return entries.get(root.dataset.productId);
    const form=target.closest?.('product-form-component, sticky-add-to-cart');
    return form ? entries.get(form.dataset.productId) : null;
  }
  function payload(e,c) {
    const map={id:c.variant.id,quantity:c.count,properties:{'Billedramme':c.withFrame?description(e):'Uden billederamme'}};
    if(!c.withFrame) return {items:[map]};
    const dims=motor().beregnRammepris(c.size,c.size), mat=pro(e)?material(e):null;
    // Existing standalone frame line properties + existing exact-total bucket resolver.
    const productionMm = String(c.size * 10 + 0.2).replace('.', ',');
    const framePrices = prices.sizes[String(c.size)].frame_surcharge_minor;
    const props = {
      'Produkt': 'Specialramme',
      'Bykort': e.config.title,
      'Bykortvariant': String(c.variant.id),
      'Billedmål': `${c.size} x ${c.size} cm`,
      'Produktionsmål': `${productionMm} x ${productionMm} mm`,
      'Bredde': `${c.size} cm`,
      'Højde': `${c.size} cm`,
      'Farve': mat ? mat.navn : motor().farve(e.ramme.farve).navn,
      'Farve anvendes som': mat ? 'Pro Materialets egen palette' : 'Valgt farve fra trin 2',
      'Profil': '3D Kunstramme - Standard',
      'Overflade': mat?.navn || 'Glat',
      'Overfladetype': mat ? 'Pro Materialer' : 'Dekorative mønstre',
      'Overfladetillæg': `${mat ? (framePrices.pro - framePrices.klassisk) / 100 : 0} kr`,
      'Antal rammedele': String(dims.dele),
      'Samlet rammelængde': `${dims.samletLaengde.toFixed(1)} cm`,
      'Bagplade': 'Nej',
      'Bagplade + kickstand': 'Nej',
      'Personlig tekst': 'Nej',
      '3D kunst': e.config.title,
      '3D kunst udførelse': c.style === 'hvid' ? 'Hvid' : 'Farve',
      '3D kunst mål': `${c.size * 10} x ${c.size * 10} mm`,
      'Beregnet pris': `${c.surcharge / 100} kr`
    };
    return {items:[map,...c.parts.map(v=>({id:v.id,quantity:v.quantity*c.count,properties:props}))]};
  }
  async function add(e) {
    if(e.busy) return;
    const c=calculation(e); if(c.error) {e.error=c.error;schedule();return;}
    e.busy=true;e.error='';sync();
    try {
      const response=await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload(e,c))});
      const data=await response.json();
      if(!response.ok) throw new Error(data.description || 'Kunne ikke lægge i kurven.');
      // One atomic request; never replay automatically after an ambiguous response.
      location.assign((window.Shopify?.routes?.root || '/')+'cart');
    } catch(error) {e.error=error.message || 'Kontrollér kurven, før du prøver igen.';e.busy=false;schedule();}
  }
  window.addEventListener('click',event=>{
    const action=event.target.closest?.('button[name="add"], .sticky-add-to-cart__button');
    const e=action && entryFor(action);
    if(e) {event.preventDefault();event.stopImmediatePropagation();add(e);return;}
    const b=event.target.closest?.('[data-frame-color],[data-frame-finish-mode],[data-frame-pro],[data-frame-pro-category],[data-frame-pro-back]');
    const item=b && entryFor(b);if(!item || b.disabled)return;
    const d=b.dataset;
    if(d.frameColor)item.ramme.farve=d.frameColor;
    if(d.frameFinishMode==='classic')item.ramme.overflade='solid';
    if(d.frameFinishMode==='pro' && readiness.proMaterial.size)item.ramme.overflade='proMaterial';
    if(d.framePro && ready('proMaterial',d.framePro))item.ramme.proMateriale=d.framePro;
    if(d.frameProCategory!==undefined)item.ramme.proKategori=d.frameProCategory;
    if(d.frameProBack!==undefined)item.ramme.proKategori='';
    item.error='';schedule();
  },true);
  window.addEventListener('submit',event=>{const e=entryFor(event.target);if(e){event.preventDefault();event.stopImmediatePropagation();add(e);}},true);
  document.addEventListener('change',event=>{const e=entryFor(event.target);if(e && event.target.matches('input[name^="nf-frame-"]'))e.choice=event.target.value;e && (e.error='');schedule();});
  document.addEventListener('input',event=>{
    const e=entryFor(event.target);if(!e)return;
    if(event.target.matches('[data-frame-pro-search]')){e.ramme.proSoegning=event.target.value;if(event.target.value.trim())e.ramme.proKategori='';const p=prices.sizes[String(getSize(e))].frame_surcharge_minor;e.ui.renderProMaterials((p.pro-p.klassisk)/100,readiness.valid && readiness.proMaterial.size>0);e.signature='';}
    else schedule();
  });
  for(const name of ['variant:update','product:variant-change','shopify:section:load'])document.addEventListener(name,schedule);
  new MutationObserver(schedule).observe(document.querySelector('#MainContent')||document.body,{childList:true,subtree:true});
  Promise.all([api.validateReadiness(readiness,motor),motor().hentPrisvarianter(['specialramme','specialramme-251-500-kr','specialramme-501-750-kr','specialramme-751-1000-kr']).then(value=>{buckets=value;})]).finally(()=>{loading=false;for(const e of entries.values())e.signature='';schedule();});
  sync();
})();
